export class Password {
    public static readonly minLength = 8;
    public static readonly maxLength = 64;

    private static readonly MIN_COMPLEXITY = 3;

    public readonly digit: boolean;
    public readonly upperCase: boolean;
    public readonly lowerCase: boolean;
    public readonly specialChar: boolean;

    public readonly forbiddenChar: boolean;

    private readonly minLength: boolean;
    private readonly maxLength: boolean;

    constructor(
        public readonly password = '',
        public readonly validatePassword = ''
    ) {
        this.digit = this.password.match(/[0-9]/g) !== null;
        this.upperCase = this.password.match(/[A-Z]/g) !== null;
        this.lowerCase = this.password.match(/[a-z]/g) !== null;
        this.specialChar = this.password.match(/(?=.*[ @$!%*?&#'()+,\-.\\/:;<=>[\]^_`{|}~"])/g) !== null;
        this.forbiddenChar = this.password.match(/[^0-9A-Za-z @$!%*?&#'()+,\-.\\/:;<=>[\]^_`{|}~"]/g) !== null;
        this.minLength = this.password.length >= Password.minLength;
        this.maxLength = this.password.length <= Password.maxLength;
    }

    public isValid(): boolean {
        return this.isComplexityValid() && this.isLengthValid() && this.isSpaceValid() && !this.forbiddenChar;
    }

    public isComplexityValid(): boolean {
        let nrOfCriteria = 0;

        if (this.digit) {
            nrOfCriteria++;
        }

        if (this.upperCase) {
            nrOfCriteria++;
        }

        if (this.lowerCase) {
            nrOfCriteria++;
        }

        if (this.specialChar) {
            nrOfCriteria++;
        }
        return nrOfCriteria >= Password.MIN_COMPLEXITY;
    }

    public isEqual(): boolean {
        return this.password.length > 0 && this.password === this.validatePassword;
    }

    public isSpaceValid(): boolean {
        return this.password.trim() === this.password;
    }

    private isLengthValid(): boolean {
        return this.minLength && this.maxLength;
    }
}
